
export const isNotRevoked = ({activeCaseExpertId}) => (expert) => (expert.reviewDateEpochMilli || expert.id === activeCaseExpertId) && !expert.isCoReview
export const isNotRevokedCoReview = () => (expert) => expert.revokeDateEpochMilli == null && expert.isCoReview
